import { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@core/text";
interface FeaturedCarouselProps {
  dataLength: number;
  renderFeaturedCards: () => React.ReactNode;
  backgroundColor?: string;
  gradientColor?: string;
}

export const FeaturedCarousel = ({
  dataLength,
  renderFeaturedCards,
  backgroundColor,
  gradientColor,
}: FeaturedCarouselProps) => {
  const { t } = useTranslation();
  const carouselRef = useRef<HTMLDivElement>(null);
  const autoplayTimerRef = useRef<NodeJS.Timeout>();
  const isHovering = useRef(false);

  useEffect(() => {
    const startAutoplay = () => {
      autoplayTimerRef.current = setInterval(() => {
        if (!isHovering.current && dataLength > 0) {
          if (carouselRef.current) {
            const cardWidth = 256;
            const gap = 16;
            const scrollAmount = cardWidth + gap;

            const maxScroll =
              carouselRef.current.scrollWidth - carouselRef.current.clientWidth;
            const newScrollPosition =
              carouselRef.current.scrollLeft + scrollAmount;

            if (newScrollPosition > maxScroll) {
              carouselRef.current.scrollLeft = 0;
            } else {
              carouselRef.current.scrollLeft = newScrollPosition;
            }
          }
        }
      }, 3000);
    };

    // startAutoplay();
    return () => {
      if (autoplayTimerRef.current) {
        clearInterval(autoplayTimerRef.current);
      }
    };
  }, [dataLength]);

  return (
    <div className="relative mb-8 bg-white/30 dark:bg-gray-800/30 backdrop-blur-md rounded-xl p-4 shadow-lg border border-white/20 dark:border-gray-700/20 h-full">
      <div
        className={`absolute inset-0 rounded-xl bg-gradient-to-br ${backgroundColor}`}
      />

      <div className="relative h-full">
        <div className="flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-4 mb-4">
          <div className="flex flex-col items-center">
            <div className="flex items-center justify-center space-x-2">
              <Text
                variant={"h3"}
                className="!text-gray-700 dark:!text-gray-300"
              >
                {t("homeworkIdeas.mostLiked")}
              </Text>
            </div>
            <div
              className={`h-0.5 bg-gradient-to-r ${gradientColor} w-full mt-2 rounded-full`}
            />
          </div>
        </div>

        <div
          ref={carouselRef}
          className="relative w-full overflow-x-auto rounded-xl scroll-smooth scrollbar-"
          onMouseEnter={() => (isHovering.current = true)}
          onMouseLeave={() => (isHovering.current = false)}
        >
          <div className="flex space-x-4 p-2 w-[100px]">
            {renderFeaturedCards()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedCarousel;
